import React, { useContext, useCallback } from 'react'
import { Context } from '../'

export default function SplitViewSidebarResize() {
    const context = useContext(Context)
    const sidebar = context.sidebar

    const onMouseMove = useCallback(
        ({ pageX }) => {
            if (pageX < 100)
                sidebar.close()
            else
                sidebar.resize(pageX)
        },
        [sidebar]
    )

    const onMouseUp = useCallback(() => {
        document.documentElement.classList.remove('ui-sv-resize-mode')
        window.removeEventListener('mouseup', onMouseUp)
        window.removeEventListener('mousemove', onMouseMove)
    }, [onMouseMove])

    const onMouseDown = useCallback(() => {
        document.documentElement.classList.add('ui-sv-resize-mode')
        window.addEventListener('mouseup', onMouseUp)
        window.addEventListener('mousemove', onMouseMove)
    }, [onMouseUp, onMouseMove])

    const onDoubleClick = useCallback(() => onMouseMove({ pageX: 0 }), [onMouseMove])

    return (
        <div
            className={'ui-sv-resize'}
            onDoubleClick={onDoubleClick}
            onMouseDown={onMouseDown} />
    )
}
